import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-623cf5eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "element-loading-text": "正在加载数据，请稍候" }
const _hoisted_2 = { class: "dialog-footer" }
const _hoisted_3 = { style: {"text-align":"center"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 提 交 ")

import { reactive, unref, ref } from 'vue';
import { ElForm, ElMessage } from 'element-plus';

import { GbDialog } from '@/components/GbDialog/Index';

/* APIS */
import { CtAgreeApi } from '../../../apis/contract/contract.api';

/* Dtos */
import { CtAuditDto } from '../../../apis/contract/contract.type';
import { GetStampUseInfoApi } from '@/apis/basics/stamps.api';


export default /*#__PURE__*/_defineComponent({
  emits: ['refresh'],
  setup(__props, { expose, emit: $emits }) {



const elFormRef = ref<ComponentRef<typeof ElForm>>();

const state = reactive({
	show: false,
	loading: false,
	stampInfo: null,
	title: '',
	detail: {} as any,
});

const auditSchema = reactive<CtAuditDto>({
	id: '',
	revision: '',
	file_total: 1,
	remark: '',
});

const load = {
	getUseStampInfo: async (ctId: string) => {
		const { succeeded, errors, data } = await GetStampUseInfoApi(ctId);
		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			state.stampInfo = data;
			auditSchema.file_total = data.file_total ?? -1;
			state.title = `${data.stamp_name}(${data.stamp_no})`;
		}
	},
};

const btnActions = {
	/* 提交数据 */
	submit: () => {
		unref(elFormRef)?.validate(async (isValid: boolean) => {
			if (!isValid) return;
			state.loading = true;
			const formData = unref(auditSchema);
			const { succeeded, errors } = await CtAgreeApi(formData);

			if (!succeeded) {
				ElMessage.error(errors);
			} else {
				ElMessage.success('提交审批成功。');
				$emits('refresh', succeeded);
				state.show = false;
			}

			state.loading = false;
		});
	},
};

/* 打开对话框 */
const showDialog = async (contract: any) => {
	unref(auditSchema).id = contract.id;
	unref(auditSchema).revision = contract.revision;

	await load.getUseStampInfo(contract.id);
	state.detail = contract;
	state.show = true;
};

expose({ showDialog });

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(state).show) = $event)),
    title: "用印确认",
    style: {"width":"600px"}
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            type: "primary",
            style: {"width":"80px"},
            disabled: _unref(state).loading,
            onClick: btnActions.submit,
            size: "small"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(ElForm), {
          ref_key: "elFormRef",
          ref: elFormRef,
          model: _unref(auditSchema),
          "label-position": "top",
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "合同编号" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(state).detail.no,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).detail.no) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "合同名称" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(state).detail.name,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).detail.name) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "申请印章" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(state).title,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).title) = $event)),
                          type: "text",
                          disabled: true
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "用印文件(一式N份)",
                      prop: "file_total"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          style: {"width":"100%"},
                          modelValue: _unref(auditSchema).file_total,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(auditSchema).file_total) = $event)),
                          min: 1,
                          max: 10,
                          placeholder: "用印文件数量(一式N份)"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "备注",
                      prop: "remark"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(auditSchema).remark,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(auditSchema).remark) = $event)),
                          type: "textarea",
                          "show-word-limit": "",
                          rows: "5",
                          maxlength: "150",
                          placeholder: "用印确认备注"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})